import { useSegwayRouter } from '@/features/shared/hooks/useSegwayRouter'
import { getRetailerFeaturedPromotionsUrl } from '@shared/constants/routes'
import { useOnUngatedCategories } from '@/features/shop/hooks/useOnUniversalCategories'
import { useMarketingZip } from '@/features/shop/components/UngatedCategoryPage/hooks'
import { useTotalActiveFiltersLength } from '@/features/shop/services/Search/hooks'
import { findCategoryFacet } from '@/features/shop/services/Search/utils'
import { type Facet } from '@/features/shop/services/Search/types'
import { stringifyWithCatIdsArray } from '@/features/shared/utils/queryString'
import { useIsPage } from '@/features/shared/hooks/useIsPage'
import { useSearchQueryParams } from '@/features/shared/hooks/search'
import { useUserStoreName } from '@/features/account/services/User/hooks'
import { singleValueOrNone } from '@/features/shared/serverUtils/request'

export const useOnClearAllFilters = (facets: Facet[]) => {
  const router = useSegwayRouter()
  const zip = useMarketingZip()
  const activeFiltersLength = useTotalActiveFiltersLength(facets)
  const ungatedPathname = useOnUngatedCategories()
  const isFeaturedPromotionsPage = useIsPage().RETAILER_FEATURED_PROMOTIONS
  const searchQueryParams = useSearchQueryParams()
  const storeName = useUserStoreName()

  const onClearAllFilters = () => {
    const { query, category_id, promotion_category_id, category_ids, category_name } =
      searchQueryParams
    const [h1CategoryItem] = findCategoryFacet(facets)?.items || []
    const params = {
      ...(query && { query }),
      ...(!query && category_id && !category_ids && { category_id: h1CategoryItem?.id }),
      ...(ungatedPathname && zip && { zip }),
      category_name,
    }
    const stringifiedParams = stringifyWithCatIdsArray(params, String(category_ids ?? ''))

    // featured promotion page requires a different path
    const promoCategoryId = singleValueOrNone(promotion_category_id) ?? 0
    const route = isFeaturedPromotionsPage
      ? `${getRetailerFeaturedPromotionsUrl(
          storeName,
          promoCategoryId,
        )}?promotion_category_id=${promoCategoryId}`
      : `${ungatedPathname ?? window.location.pathname}?${stringifiedParams}`
    return router.push(route, { shallow: true })
  }

  return {
    showClearButton: activeFiltersLength > 0,
    onClearAllFilters,
  }
}
